import React from "react";
import ApplicationsPage from "./ApplicationsPage";

const RejectedApplications = () => <ApplicationsPage status="rejected" />;

export default RejectedApplications;
